// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-container {
  position: relative;
  display: inline-block;
}

.dropdown input {
  box-sizing: border-box;
  width: 100%;
  padding: 12px;
  font-size: 16px;
  height: 44px;
  border: 1px solid #ddd;
}

.dropdown-content {
  display: block;
  position: absolute;
  background-color: #f6f6f6;
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 8px;
  z-index: 1;
  max-height: 200px;
  overflow-y: auto;

}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.uniBtnPurple {
  /* height: 42px; */
  padding: 5px 22px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: #9C44C0;
  box-sizing: border-box;
}
.uniBtnPurple:disabled {
  background-color:  #c4a7cf;
}
.uniBtnBlue{
  height: 42px;
  padding: 3px 22px 5px 22px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: #005EEF;
}

.dropdown-content a:hover {
  background-color: #ddd;
}


.prompt-library-card-heading {
  font-size: 18px;
  font-style: normal;
  font-weight: 900;
  line-height: 120%;
  /* 21.6px */
}

.prompt-library-card-heading:hover {
  text-decoration: underline;
}

.prompt-library-card-edit:hover {
  text-decoration: underline;
}

.prompt-library .small-box {
  background-color: #9C44C0;
  color: #FFFFFF;
  min-height: 175px;
}

.prompt-library .card-header {
  padding-left: 10px !important;
}


@media(max-width:1300px) {

  .uniBtnPurple,
  .dropdown input {
    font-size: 14px;
  }

  b,
  .prompt-library-card-heading {
    font-size: 16px;
  }


  h4 {
    font-size: 14px;
  }

}`, "",{"version":3,"sources":["webpack://./src/Pages/PromptLibrary.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;;AAElB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;;AAGA;;EAEE;;IAEE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;;EAGA;IACE,eAAe;EACjB;;AAEF","sourcesContent":[".dropdown-container {\n  position: relative;\n  display: inline-block;\n}\n\n.dropdown input {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 12px;\n  font-size: 16px;\n  height: 44px;\n  border: 1px solid #ddd;\n}\n\n.dropdown-content {\n  display: block;\n  position: absolute;\n  background-color: #f6f6f6;\n  width: 100%;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  z-index: 1;\n  max-height: 200px;\n  overflow-y: auto;\n\n}\n\n.dropdown-content a {\n  color: black;\n  padding: 12px 16px;\n  text-decoration: none;\n  display: block;\n}\n\n.uniBtnPurple {\n  /* height: 42px; */\n  padding: 5px 22px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  background: #9C44C0;\n  box-sizing: border-box;\n}\n.uniBtnPurple:disabled {\n  background-color:  #c4a7cf;\n}\n.uniBtnBlue{\n  height: 42px;\n  padding: 3px 22px 5px 22px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  background: #005EEF;\n}\n\n.dropdown-content a:hover {\n  background-color: #ddd;\n}\n\n\n.prompt-library-card-heading {\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 900;\n  line-height: 120%;\n  /* 21.6px */\n}\n\n.prompt-library-card-heading:hover {\n  text-decoration: underline;\n}\n\n.prompt-library-card-edit:hover {\n  text-decoration: underline;\n}\n\n.prompt-library .small-box {\n  background-color: #9C44C0;\n  color: #FFFFFF;\n  min-height: 175px;\n}\n\n.prompt-library .card-header {\n  padding-left: 10px !important;\n}\n\n\n@media(max-width:1300px) {\n\n  .uniBtnPurple,\n  .dropdown input {\n    font-size: 14px;\n  }\n\n  b,\n  .prompt-library-card-heading {\n    font-size: 16px;\n  }\n\n\n  h4 {\n    font-size: 14px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
